import { SigeBlock, DEFAULT_PIKTO_KEYS, piktoPfad, piktoPfadLokal, aufloesePikto } from './types';

// Zeichen liegen als PNG vor (Bucket + lokal). jsPDF kann PNG direkt einbetten — wir
// brauchen also kein SVG-Rastern und kein Canvas. Bevorzugt: PNG per fetch → Base64
// (umgeht jegliches Canvas-Taint-Problem). Fallback: <img> → Canvas (PNG taintet nicht).

const bytesZuBase64 = (buf: ArrayBuffer): string => {
  const bytes = new Uint8Array(buf);
  let bin = '';
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    bin += String.fromCharCode.apply(null, Array.from(bytes.subarray(i, i + chunk)));
  }
  return btoa(bin);
};

// A) PNG-Bytes holen und als Data-URL zurückgeben (ohne Canvas).
const pngPerFetch = async (url: string): Promise<string | null> => {
  try {
    const res = await fetch(url, { cache: 'reload' });
    if (!res.ok) return null;
    return 'data:image/png;base64,' + bytesZuBase64(await res.arrayBuffer());
  } catch {
    return null;
  }
};

// B) PNG über <img> laden und per Canvas exportieren (PNG → kein Taint bei ACAO:*).
const pngPerCanvas = (url: string): Promise<string | null> =>
  new Promise(resolve => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const c = document.createElement('canvas');
        c.width = img.naturalWidth || 256;
        c.height = img.naturalHeight || 256;
        const ctx = c.getContext('2d');
        if (!ctx) { resolve(null); return; }
        ctx.drawImage(img, 0, 0);
        resolve(c.toDataURL('image/png'));
      } catch (e) {
        console.warn('[pikto] Canvas-Export blockiert', url, e);
        resolve(null);
      }
    };
    img.onerror = () => resolve(null);
    img.src = url + (url.includes('?') ? '&' : '?') + 'cb=1';
  });

// Ein Zeichen über mehrere Quellen/Methoden laden.
const ladeEin = async (iso: string): Promise<string | null> => {
  for (const url of [piktoPfad(iso), piktoPfadLokal(iso)]) {
    const png = (await pngPerFetch(url)) || (await pngPerCanvas(url));
    if (png) return png;
  }
  return null;
};

// Welche Piktogramm-Keys soll der Plan zeigen?
export const piktoKeysFuer = (bloecke: SigeBlock[]): string[] => {
  const b = bloecke.find(x => x.typ === 'piktogrammfeld');
  return b?.inhalt?.icons?.length ? b.inhalt.icons : DEFAULT_PIKTO_KEYS;
};

// icons-Eintrag (Legacy-Key ODER ISO-Code) → PNG-DataURL (sofern Bild ladbar)
export const ladePiktogrammBilder = async (bloecke: SigeBlock[]): Promise<Record<string, string>> => {
  const keys = piktoKeysFuer(bloecke);
  const out: Record<string, string> = {};
  await Promise.all(
    keys.map(async key => {
      const def = aufloesePikto(key);
      if (!def?.iso) return;
      const png = await ladeEin(def.iso);
      if (png) out[key] = png;
    })
  );
  console.info(`[pikto] geladen: ${Object.keys(out).length}/${keys.length}`, keys.filter(k => !out[k]));
  return out;
};

export const pruefePiktoQuelle = async (iso: string): Promise<string> => {
  const url1 = piktoPfad(iso);
  const url2 = piktoPfadLokal(iso);
  const s1 = await fetch(url1, { method: 'HEAD' }).then(r => r.ok).catch(() => false);
  if (s1) return 'Bucket OK';
  const s2 = await fetch(url2, { method: 'HEAD' }).then(r => r.ok).catch(() => false);
  if (s2) return 'Lokal OK';
  return 'Nicht gefunden';
};

